<template>
<div class="chapter">
<div class="inner_page">
<p class="textcentera"><a id="ch00_fm06"></a><a id="page_vii"><strong>The intensity of the longing is what does all the work.</strong></a></p><a id="page_vii">
<p class="textcenter1"><strong>—Rumi, translation by Robert Bly</strong></p>
<p class="images1"><img alt="image" src="images/f00vii-01.jpg"/></p>
<p class="textcenter"><strong>Had I been a man I might have explored the Poles or climbed<br/>Mount Everest, but as it was my spirit found outlet in the air. …</strong></p>
</a><p class="textcenter1"><a id="page_vii"><strong>—Amy Johnson, British aviatrix,</strong> <em>Myself When Young</em></a><a id="page_viii"></a></p><a id="page_viii">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm06.vue?7f83324b